<div *ngIf="!loadingPage else loadingTemplate">
  <div class="row mb-5">
    <div class="col card" [formGroup]="formGroup">
      <div class="col p-0">
        <h3 class="mb-4">Documentos</h3>
      </div>

      <div class="row p-0 mb-3">
        <div class="col-9 p-0">
          <app-basic-input id="name" label="Nome" controlName="name" [formGroup]="formGroup"></app-basic-input>
        </div>

        <div class="col-3 p-0 pl-3">
          <app-select-input [formGroup]="formGroup" [options]="typeOptions" id="type" label="Tipo" [clearable]="true"
            (onValueChange)="getType()"></app-select-input>
        </div>
      </div>

      <div class="row p-0">
        <div class="col-12 p-0">
          <app-basic-input id="drive_id" label="Drive ID" controlName="drive_id" [formGroup]="formGroup">
          </app-basic-input>
        </div>
      </div>

      <div class="row p-0" *ngIf="isMedical">
        <div class="col-12 mt-3 p-0">
          <app-select-input [formGroup]="formGroup" [options]="professionalList" id="professional" label="Professional"
            [clearable]="true"></app-select-input>
        </div>
      </div>
    </div>
  </div>

  <div class="row justify-content-end mt-5 mb-5">
    <div class="col-12 col-md-3 mb-3">
      <button (click)="cancelHandler()" class="btn btn-link btn-lg" type="button">
        Cancelar
      </button>
    </div>

    <div class="col-12 col-md-3 mb-3" *ngIf="button">
      <button (click)="removeHandler()" [disabled]="submittingRemove || !canRemove" class="btn btn-secondary btn-lg"
        type="button">
        {{removeButton}}
        <span class="spinner-border" *ngIf="submittingRemove"></span>
      </button>
    </div>

    <div class="col-12 col-md-3 mb-3">
      <button (click)="submitHandler()" [disabled]="submitting || !canSave" class="btn btn-primary btn-lg"
        type="button">
        {{submitButton}}
        <span class="spinner-border" *ngIf="submitting"></span>
      </button>
    </div>
  </div>
</div>

<ng-template #loadingTemplate>
  <div class="col card full-loading text-center">
    <div class="spinner-border spinner-border-xl" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</ng-template>
